import { render, staticRenderFns } from "./PrinterConfig.vue?vue&type=template&id=453f4cb9&scoped=true"
import script from "./PrinterConfig.vue?vue&type=script&lang=js"
export * from "./PrinterConfig.vue?vue&type=script&lang=js"
import style0 from "./PrinterConfig.vue?vue&type=style&index=0&id=453f4cb9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "453f4cb9",
  null
  
)

export default component.exports